/* eslint-disable */

import Highcharts, { ExtremesObject } from 'highcharts';
import { ChartSyncService } from 'src/app/domain/kpi/components/charts/chart-sync-service.service';
import {
  HUNDRED_THOUSANDS,
} from "../../../../organization/components/fair-value-and-pp-charts/service/calculations-service/fair-value-and-pp-charts.service";
// eslint-disable-next-line
export type HighchartsOptions = any;

export const CHART_COLORS = {
  grey: '#5E6F78',
  white: '#FFFFFF',
  obsidianBlack: '#333333',
  mysticOpal: '#FBDDBC',
  yellow10: '#FFDD2D',
  orange: '#FBA74B',
  green: '#5CC3BB',
  main8: '#00948e',
  red10: '#C2451E',
  red: '#FF8078',
  purple: '#B977A8',
  black6: '#C2C6C8',
  black7: '#A1A6A9',
  black9: '#6F777B',
  black10: '#4E585C',
  black12: '#263238',
  brightOrange: '#FB992F',
  vibrantMagenta: '#C21EBB',
  columnCharts: ['#5CC3BB', '#5E6F78', '#FFDD2D', '#778c99', '#B2B2B4'],
  default: ['#5E6F78', '#41AFAB', '#92D2CF', '#FFDD2D', 'rgba(94, 111, 120, 0.18)', '#D2D5D6', '#B2B2B4'],
  commitmentAllocation: ['#5E6F78', '#41AFAB', '#FADCBB', '#FBA74B', '#92D2CF'],
  opEx: ['#5E6F78', '#FFDD2D', '#41AFAB', '#92D2CF'],
  maRaisedByIndustry: ['#01948E', '#77C1BB', '#1A8FFF', '#80C1FF', '#FBA74B', '#FBDDBC', '#A2539B', '#B977A8', '#A1A6A9', '#5F6F78']
};

export const CHART_FONTS = {
  title1: '1.5625rem',
  font2: '1.09375rem',
  font3: '0.85rem',
  font4: '0.78125rem',
  caption2: '0.625rem',
};

export const CHART_STYLES = {
  lang: {
    thousandsSep: ',',
    decimalPoint: '.',
  },

  creditsHidden: {
    enabled: false,
  },

  title: {
    color: CHART_COLORS.black12,
    fontSize: CHART_FONTS.font2,
    fontWeight: 600,
    textAlign: 'left',
    fontFamily: 'Inter, sans-serif',
  },

  titleStyle: {
    color: CHART_COLORS.black10,
    fontSize: CHART_FONTS.title1,
    fontWeight: 'bold',
    fontFamily: 'Inter, sans-serif',
  },

  legendHidden: {
    enabled: false,
  },

  legend: (align = 'right', floating = false) => ({
    layout: 'horizontal',
    align: align,
    verticalAlign: 'top',
    floating: floating,
    itemStyle: {
      color: CHART_COLORS.black12,
      cursor: 'pointer',
      fontSize: CHART_FONTS.font3,
      textOverflow: 'ellipsis',
      fontFamily: 'Inter, sans-serif',
      fontWeight: 500,
    },
    style: {
      transform: 'translate(50, 50)  !important',
    },
    symbolWidth: 0, // hide real symbol (in case marker symbol is used)
    symbolHeight: 0, // hide real symbol (in case marker symbol is used)
    squareSymbol: false,
    useHTML: true, // needed to use labelFormatter()
    labelFormatter() {
      return `<span style="display: inline-flex; align-items: center;">
      <!--      This is dot-->
      <span style="width: 0.75rem; height: 0.75rem; border-radius: 50%; background-color: ${this.color}; display: inline-block; margin-right: 0.325rem;"></span>
      ${this.name}
    </span>`;
    },
  }),

  tooltip: {
    shared: true,
    useHTML: true,
    headerFormat: '<span style="font-size: 0.8rem"><b>{point.key}</b></span><br>',
    style: { fontSize: CHART_FONTS.font4 },
    valueSuffix: ' M',
  },

  tooltipTwoLines: {
    shared: true,
    borderColor: '#EEEFF0',
    backgroundColor: CHART_COLORS.white,
    borderRadius: 12,
    shadow: false,
    useHTML: true,
    headerFormat: '<span style="font-size: 0.8rem; padding-bottom: 0.5rem"><b>{point.key}</b></span><br><br>',
    style: { fontSize: CHART_FONTS.font4 },
    valueSuffix: ' M',
    pointFormat: '{series.name}:<b> $ {point.y:.2f}</b><br>',
    pointFormatter() {
      const colorDot = '<span style="color: ' + this.color + '">&#9679;</span>';
      const formattedValue = Highcharts.numberFormat(this.y, 0, '.', ',');
      return colorDot + ' ' + this.series.name + ': <b>' + formattedValue + '</b><div>';
    },
  },

  tooltipTwoLinesNoDollar: {
    shared: true,
    borderColor: '#EEEFF0',
    backgroundColor: CHART_COLORS.white,
    borderRadius: 12,
    shadow: false,
    useHTML: true,
    headerFormat: '<span style="font-size: 0.8rem; padding-bottom: 0.5rem"><b>{point.key}</b></span><br><br>',
    style: { fontSize: CHART_FONTS.font4 },
    valueSuffix: ' M',
    pointFormat: '{series.name}:<b> {point.y:.2f}</b><br>',
    pointFormatter() {
      const colorDot = '<span style="color: ' + this.color + '">&#9679;</span>';
      const formattedValue = Highcharts.numberFormat(this.y, 0, '.', ',');
      return colorDot + ' ' + this.series.name + ': <b>' + formattedValue + '</b><div>';
    },
  },

  tooltipTwoLinesForMillions: {
    shared: true,
    borderColor: '#EEEFF0',
    backgroundColor: CHART_COLORS.white,
    borderRadius: 12,
    shadow: false,
    useHTML: true,
    headerFormat: '<span style="font-size: 0.8rem"><b>{point.key}</b></span><br><br>',
    style: { fontSize: CHART_FONTS.font4 },
    valueSuffix: ' M',
    pointFormat: '{series.name}:<b> $ {point.y:.2f}M</b><br>',
    pointFormatter() {
      const colorDot = '<span style="color: ' + this.color + '">&#9679;</span>';
      if (this.y) {
        return colorDot + ' ' + this.series.name + ': <b>' + this.y.toFixed(2) + 'M</b><br>';
      }
      return colorDot + ' ' + this.series.name + ': <b>-</b><br>';

    },
  },

  tooltipTwoLinesWithUnitFormatter: (decimals = 2) =>  ({
    shared: true,
    borderColor: '#EEEFF0',
    backgroundColor: CHART_COLORS.white,
    borderRadius: 12,
    shadow: false,
    useHTML: true,
    headerFormat: '<span style="font-size: 0.8rem"><b>{point.key}</b></span><br><br>',
    style: { fontSize: CHART_FONTS.font4 },
    pointFormat: '{series.name}:<b> $ {point.y}</b><br>',
    pointFormatter() {
      const isInteger = Number.isInteger(this.y);
      const colorDot = '<span style="color: ' + this.color + '">&#9679;</span>';
      if (this.y) {
        return colorDot + ' ' + this.series.name + ': <b>' + formatNumberWithSuffix(this.y, decimals) + '</b><br>';
      }
      return colorDot + ' ' + this.series.name + ': <b>-</b><br>';
    },
  }),

  customTooltipKpiAnalysis: {
    shared: true,
    borderColor: '#EEEFF0',
    backgroundColor: CHART_COLORS.white,
    borderRadius: 12,
    shadow: false,
    useHTML: true,
    headerFormat: '<span style="font-size: 0.8rem"><b>{point.key}</b></span><br><br>',
    style: { fontSize: CHART_FONTS.font4 },
    pointFormat: '{series.name}:<b> $ {point.y}</b><br>',
    pointFormatter() {
      const decimals = getDecimalsForSmallValues(this.y);
      const colorDot = '<span style="color: ' + this.color + '">&#9679;</span>';
      if (this.y) {
        return colorDot + ' ' + this.series.name + ': <b>' + formatNumberWithSuffix(this.y, decimals) + '</b><br>';
      }
      return colorDot + ' ' + this.series.name + ': <b>-</b><br>';
    },
  },

  customFairValueTooltipWithLine: {
    shared: true,
    useHTML: true,
    borderWidth: 0, // Disable SVG border -> fix bug tooltip layover the legend
    backgroundColor: 'transparent', // Disable SVG background -> fix bug tooltip layover the legend
    style: {
      fontSize: CHART_FONTS.font4,
    },
    shadow: false,
    formatter() {
      let tooltip = '<span style="font-size: 0.8rem; padding-bottom: 0.5rem">' +
        '<b style="display: inline-block; max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">' +
        this.points[0].key + '</b></span><br><br>';
      // Build the tooltip content for the first two series and add a grey line after the second series
      this.points.forEach((point, index) => {
        const withMoic = point.series.name === 'MOIC';
        tooltip += '<span style="color:' + point.series.color + '">●</span> ' + point.series.name + ': <b>' +
          (withMoic ? (point.y ? 'x' + point.y.toFixed(2) : '-') : (point.y ? point.y.toFixed(2) + 'M' : '-') ) +
          '</b><br/>';
        if (index === this.points.length - 1) {
          tooltip += '<hr style="margin: 4px 0; border: 0; border-top: 1px solid #ccc;">';
        }
      });
      // Calculate the fair value based on the negativity of the totals
      let fairValueData: number = 0;
      if (this.points.length === 3) {
        fairValueData = ((this.points[1] && this.points[1].total < 0) || (this.points[2] && this.points[2].total < 0))
          ? (this.points[1]?.total + this.points[2]?.total) : this.points[1]?.total;
      } else {
        fairValueData = ((this.points[0] && this.points[0].total < 0) || (this.points[0] && this.points[1].total < 0))
          ? (this.points[0]?.total + this.points[1]?.total) : this.points[0]?.total;
      }
      tooltip += 'Fair value: <b>' + (fairValueData ? fairValueData.toFixed(2) + 'M' : '-') + '</b><br/>';

      return addNotTransparentTooltipBackground(tooltip)
    },
  },

  tooltipTwoLinesForThousands: {
    shared: true,
    borderColor: '#EEEFF0',
    backgroundColor: CHART_COLORS.white,
    borderRadius: 12,
    shadow: false,
    useHTML: true,
    headerFormat: '<span style="font-size: 0.8rem; padding-bottom: 0.5rem"><b>{point.key}</b></span><br><br>',
    style: { fontSize: CHART_FONTS.font4 },
    valueSuffix: ' K',
    pointFormat: '{series.name}:<b> $ {point.y:.2f}K</b><br>',
    pointFormatter() {
      const colorDot = '<span style="color: ' + this.color + '">&#9679;</span>';
      return colorDot + ' ' + this.series.name + ': <b>' + this.y.toFixed(2) + 'K</b><div>';
    },
  },

  tooltipWithSuffixAndTotal: (decimals = 0) => ({
    shared: true,
    borderColor: '#EEEFF0',
    backgroundColor: CHART_COLORS.white,
    borderRadius: 12,
    shadow: false,
    useHTML: true,
    headerFormat: '<span style="font-size: 0.8rem"><b>{point.key.period}\
      </b></span><br><span style="font-weight: 500; color: #00948E">{point.key.budget}</span><br><br>',
    style: { fontSize: CHART_FONTS.font4 },
    formatter() {
      let total = 0;
      let tooltipHtml = '<span style="font-size: 0.8rem"><b>' +
        this.x.period + '</b></span><br><span style="font-weight: 500; color: #00948E">'
        + this.x.budget + (this.x.budget ? '</span><br><br>' : '</span><br>');

      this.points.forEach((point) => {
        if (point.y !== 0) {
          const colorDot = '<span style="color: ' + point.color + '">&#9679;</span>';
          const formattedValue = formatNumberWithSuffix(point.y, decimals);
          tooltipHtml += '<div style="text-align: left;">' + colorDot + ' ' + point.series.name + ': <b>' + formattedValue + '</b></div>';
          total += point.y;
        }
      });

      if (total !== 0) {
        const totalFormatted = formatNumberWithSuffix(total, decimals);
        tooltipHtml += '<br>Total: <b>' + totalFormatted + '</b>';
      }

      return tooltipHtml;
    },
  }),

  tooltipOneLineWithPcnt: {
    shared: true,
    borderColor: '#EEEFF0',
    backgroundColor: CHART_COLORS.white,
    borderRadius: 12,
    shadow: false,
    useHTML: true,
    headerFormat: '<span style="font-size: 0.8rem; padding-bottom: 0.5rem"><b>{point.key}</b></span><br><br>',
    style: { fontSize: CHART_FONTS.font4 },
    valueSuffix: ' M',
    pointFormat: '{series.name}:<b> $ {point.y:.2f}M</b><br>',
    pointFormatter() {
      const colorDot = '<span style="color: ' + this.color + '">&#9679;</span>';
      return '<div style="text-align: center;">' + colorDot + ' ' + this.series.name + ': <b>' + this.y.toFixed(2) + 'M</b></div>' +
        '<div style="text-align: right; font-size: 0.8rem; color: #999">' + this.percentage.toFixed(2) + '%</div>';
    },
  },

  tooltipOneLineWithX: {
    shared: true,
    borderColor: '#EEEFF0',
    backgroundColor: CHART_COLORS.white,
    borderRadius: 12,
    shadow: false,
    useHTML: true,
    headerFormat: '<span style="font-size: 0.8rem; padding-bottom: 0.5rem"><b>{point.key}</b></span><br><br>',
    style: { fontSize: CHART_FONTS.font4 },
    valueSuffix: ' M',
    pointFormat: '{series.name}:<b>x{point.y:.2f}</b><br>',
    pointFormatter() {
      const colorDot = '<span style="color: ' + this.color + '">&#9679;</span>';
      return '<div style="text-align: left; background-color: white;">'
        + colorDot + ' ' + this.series.name + ': <b>x' + this.y.toFixed(2) + '</b></div>';
    },
  },

  maVintageTooltip: (typeOfChart) => ({
    shared: true,
    borderWidth: 0, // Disable SVG border -> fix bug tooltip layover the legend
    backgroundColor: 'transparent', // Disable SVG background -> fix bug tooltip layover the legend
    borderRadius: 12,
    shadow: false,
    useHTML: true,
    headerFormat: '<span style="font-size: 0.8rem; padding-bottom: 0.5rem"><b>{point.key}</b></span><br><br>',
    style: {fontSize: CHART_FONTS.font4},
    formatter() {
      let tooltip = `<span style="font-size: 0.8rem; padding-bottom: 0.5rem"><b>${this.points[0].key}</b></span><br><br>`;
      this.points.forEach((point, index) => {
        const colorDot = `<span style="color: ${point.series.color}">&#9679;</span>`;
        let value = typeOfChart === 'IRR' ? `${point.y.toFixed(2)}%` : `x${point.y.toFixed(2)}`;
        tooltip += `${colorDot} ${point.series.name}: <b>${value}</b><br/>`;

        // Add gray line before the fourth series
        if (index === 2 && this.points[3]) {
          tooltip += '<hr style="margin: 4px 0; border: 0; border-top: 1px solid #ccc;">';
        }
      });

      return addNotTransparentTooltipBackground(tooltip)
    },
  }),

  maDilutionTooltip: {
    shared: true,
    borderColor: '#EEEFF0',
    backgroundColor: CHART_COLORS.white,
    borderRadius: 12,
    shadow: false,
    useHTML: true,
    style: { fontSize: CHART_FONTS.font4 },
    formatter() {
      let tooltipHtml = '<span style="font-size: 0.8rem"><b>' + this.x + '</b></span><br><br>'

      // Track the index to apply different formatting for the first two and third values
      this.points.forEach((point, index) => {
        if (point.y !== 0) {
          const colorDot = '<span style="color: ' + point.color + '">&#9679;</span>';
          let formattedValue;

          // Format the first two values with suffix and the third as percentage
          if (index < 2) {
            formattedValue = formatNumberWithSuffix(point.y);
          } else {
            formattedValue = point.y.toFixed(2) + '%';
          }
          tooltipHtml += '<div style="text-align: left;">' + colorDot + ' ' + point.series.name + ': <b>' + formattedValue + '</b></div>';
        }
      });

      return tooltipHtml;
    },
  },

  tooltipWithPcnt: (decimals = 2) => ({
    shared: true,
    borderColor: '#EEEFF0',
    backgroundColor: CHART_COLORS.white,
    borderRadius: 12,
    shadow: false,
    useHTML: true,
    headerFormat: '<span style="font-size: 0.8rem; padding-bottom: 0.5rem; background-color: white;"><b>{point.key}</b></span><br><br>',
    style: {
      fontSize: CHART_FONTS.font4,
    },
    valueSuffix: ' M',
    pointFormatter() {
      const colorDot = '<span style="color: ' + this.color + '">&#9679;</span>';
      return '<div style="text-align: left; background-color: white;">'
        + colorDot + ' ' + this.series.name + ': <b>' + this.y.toFixed(decimals) + '%</b></div>';
    },
  }),


  tooltipWithX: {
    shared: true,
    borderColor: '#EEEFF0',
    backgroundColor: CHART_COLORS.white,
    borderRadius: 12,
    shadow: false,
    useHTML: true,
    headerFormat: '<span style="font-size: 0.8rem; padding-bottom: 0.5rem"><b>{point.key}</b></span><br><br>',
    style: { fontSize: CHART_FONTS.font4 },
    pointFormat: '{series.name}:<b> x {point.y:.2f}K</b><br>',
    pointFormatter() {
      const colorDot = '<span style="color: ' + this.color + '">&#9679;</span>';
      return '<div style="text-align: left; background-color: white;">'
        + colorDot + ' ' + this.series.name + ': <b>x' + this.y.toFixed(2) + '</b><div>';
    },
  },

  tooltipWithSuffix: {
    shared: true,
    borderColor: '#EEEFF0',
    backgroundColor: CHART_COLORS.white,
    borderRadius: 12,
    shadow: false,
    useHTML: true,
    headerFormat: '<span style="font-size: 0.8rem"><b>{point.key.period}\
    </b></span><br><span style="font-weight: 500; color: #00948E">{point.key.budget}</span><br><br>',
    style: { fontSize: CHART_FONTS.font4 },
    pointFormat: '{series.name}:<b>x{point.y:.2f}</b><br>',
    formatter() {
      let tooltipHtml = '<span style="font-size: 0.8rem"><b>' +
        this.x.period + '</b></span><br><span style="font-weight: 500; color: #00948E">'
        + this.x.budget + (this.x.budget ? '</span><br><br>' : '</span><br>');

      this.points.forEach((point) => {
        if (point.y !== 0) {
          const colorDot = '<span style="color: ' + point.color + '">&#9679;</span>';
          const formattedValue = formatNumberWithSuffix(point.y);
          tooltipHtml += '<div style="text-align: left;">' + colorDot + ' ' + point.series.name + ': <b>' + formattedValue + '</b></div>';
        }
      });

      return tooltipHtml;
    },
  },

  aspMetricTooltip: {
    shared: true,
    borderColor: '#EEEFF0',
    backgroundColor: 'white',
    borderRadius: 12,
    shadow: false,
    useHTML: true,
    headerFormat: '<span style="font-size: 0.8rem; padding-bottom: 0.5rem">\
      <b>{point.key.period}</b></span><br><span style="font-weight: 500; \
      color: #00948E">{point.key.budget}</span><br><br>',
    style: { fontSize: CHART_FONTS.font3 },
    formatter() {
      let tooltipHtml = '<span style="font-size: 0.8rem; padding-bottom: 0.5rem"><b>' + this.points[0].key.period
        + '</b></span><br><span style="font-weight: 500; color: #00948E">'
        + this.points[0].key.budget + (this.points[0].key.budget ? '</span><br><br>' : '</span><br>');
      this.points.forEach((point) => {
        if (point.y !== 0) {
          const colorDot = '<span style="color: ' + point.color + '">&#9679;</span>';
          let formattedValue;
          if (point.series.name !== 'Growth pace') {
            formattedValue = formatNumberWithSuffix(point.y);
          } else {
            formattedValue = Highcharts.numberFormat(point.y, 2) + '%';
          }
          tooltipHtml += '<div style="text-align: left;">' + colorDot + ' ' + point.series.name + ': <b>' + formattedValue + '</b></div>';
        }
      });

      return tooltipHtml;
    },
  },

  salesMetricTooltip: {
    shared: true,
    borderColor: '#EEEFF0',
    backgroundColor: 'white',
    borderRadius: 12,
    shadow: false,
    useHTML: true,
    headerFormat: '<span style="font-size: 0.8rem; padding-bottom: 0.5rem">\
      <b>{point.key.period}</b></span><br><span style="font-weight: 500; \
      color: #00948E">{point.key.budget}</span><br><br>',
    style: { fontSize: CHART_FONTS.font3 },
    formatter() {
      let tooltipHtml = '<span style="font-size: 0.8rem; padding-bottom: 0.5rem"><b>' + this.points[0].key.period
        + '</b></span><br><span style="font-weight: 500; color: #00948E">'
        + this.points[0].key.budget + (this.points[0].key.budget ? '</span><br><br>' : '</span><br>');
      this.points.forEach((point) => {
        if (point.y !== 0) {
          const colorDot = '<span style="color: ' + point.color + '">&#9679;</span>';
          let formattedValue;
          if (point.series.name === 'New clients') {
            formattedValue = formatNumberWithSuffix(point.y, 0);
          } else {
            formattedValue = formatNumberWithSuffix(point.y, 1);

          }
          tooltipHtml += '<div style="text-align: left;">' + colorDot + ' ' + point.series.name + ': <b>' + formattedValue + '</b></div>';
        }
      });

      return tooltipHtml;
    },
  },

  cacMetricTooltip: {
    shared: true,
    borderColor: '#EEEFF0',
    backgroundColor: 'white',
    borderRadius: 12,
    shadow: false,
    useHTML: true,
    headerFormat: '<span style="font-size: 0.8rem; padding-bottom: 0.5rem">\
      <b>{point.key.period}</b></span><br><span style="font-weight: 500; \
      color: #00948E">{point.key.budget}</span><br><br>',
    style: { fontSize: CHART_FONTS.font3 },
    formatter() {
      let tooltipHtml = '<span style="font-size: 0.8rem; padding-bottom: 0.5rem"><b>' + this.points[0].key.period
        + '</b></span><br><span style="font-weight: 500; color: #00948E">'
        + this.points[0].key.budget + (this.points[0].key.budget ? '</span><br><br>' : '</span><br>');
      this.points.forEach((point) => {
        if (point.y !== 0) {
          const colorDot = '<span style="color: ' + point.color + '">&#9679;</span>';
          let formattedValue;
          if (point.series.name !== 'Payback') {
            formattedValue = formatNumberWithSuffix(point.y, 1);
          } else {
            formattedValue = Highcharts.numberFormat(point.y, 2) + '%';
          }
          tooltipHtml += '<div style="text-align: left;">' + colorDot + ' ' + point.series.name + ': <b>' + formattedValue + '</b></div>';
        }
      });

      return tooltipHtml;
    },
  },

  maNumberOfDealsTooltip: {
    shared: true,
    borderColor: '#EEEFF0',
    backgroundColor: CHART_COLORS.white,
    borderRadius: 12,
    shadow: false,
    useHTML: true,
    headerFormat: '<span style="font-size: 0.8rem; padding-bottom: 0.5rem; background-color: white;"><b>{point.key}</b></span><br><br>',
    style: {
      fontSize: CHART_FONTS.font4,
    },
    pointFormatter() {
      const periodX = this.x; // Get x-axis value (the period)

      // Calculate the total for this period (x-axis value)
      const total = this.series.chart.series.reduce((sum, series) => {
        const point = series.data.find(p => p.x === periodX);
        return sum + (point ? point.y : 0);
      }, 0);

      if (!total || !this.y) {
        return ''; // If no total or no value, return an empty string
      }

      // Format the percentage relative to the total
      const percentage = ((this.y / total) * 100);
      const colorDot = `<span style="color: ${this.color}">&#9679;</span>`;

      return `<div style="text-align: left; background-color: white;">`
        + `${colorDot} ${this.series.name}: <b>${percentage.toFixed(2)}%</b></div>`;
    },
  }
,

  pieChartTooltip: {
    shared: true,
    useHTML: true,
    headerFormat: '<span style="font-size: 0.8rem"><b>{point.key}</b></span><br>',
    style: { fontSize: CHART_FONTS.font4 },
    pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b><br>',
  },

  hiddenExportingButton: {
    enabled: false,
  },

  xAxisLabels: {
    useHTML: true,
    style: {
      fontSize: CHART_FONTS.font4,
      width: 125,
      textOverflow: 'ellipsis',
      textAlign: 'center',
    },
  },

  xAxisLabelsStyle: {
    useHtml: true,
    style: { color: CHART_COLORS.black12, fontSize: CHART_FONTS.caption2, fontFamily: 'Inter, sans-serif' },
  },

  yAxisLabelsStyle: {
    format: '{value:,.f}',
    style: { color: CHART_COLORS.black12, fontSize: CHART_FONTS.caption2, fontFamily: 'Inter, sans-serif' },
  },

  yAxisLabelsStyleWithM: {
    format: '{value:.1f}M',
    style: { color: CHART_COLORS.black12, fontSize: CHART_FONTS.caption2, fontFamily: 'Inter, sans-serif' },
  },

  yAxisLabelsStyleWithSuffix: {
    formatter() {
      return formatNumberWithSuffix(this.value);
    },
    style: {
      color: CHART_COLORS.black12,
      fontSize: CHART_FONTS.caption2,
      fontFamily: 'Inter, sans-serif',
    },
  },

  yAxisLabelsStyleWithPcnt: {
    format: '{value}%',
    style: { color: CHART_COLORS.black12, fontSize: CHART_FONTS.caption2, fontFamily: 'Inter, sans-serif' },
  },

  pieChartStates: {
    inactive: {
      opacity: 0.2,
    },
    hover: {
      enabled: true,
      halo: {
        size: 3,
      },
    },
  },

  drillDownOptions: {
    allowPointDrilldown: false,
    breadcrumbs: {
      format: '&nbsp;&nbsp;❮ Back&nbsp;&nbsp;',
      showFullPath: false,
      buttonTheme: {
        fill: '#4A5C65FF',
        stroke: '#4A5C65FF',
        r: 12,
        style: {
          color: CHART_COLORS.white,
        },
        states: {
          hover: {
            fill: '#41515a',
            style: {
              color: CHART_COLORS.white,
            },
            stroke: '#41515a',
          },
        },
      },
      floating: true,
      position: {
        align: 'left',
        verticalAlign: 'top',
        x: '1rem',
        y: '1rem'
      },
    },
    activeAxisLabelStyle: {
      color: '#333333',
      fontSize: CHART_FONTS.font4,
      fontWeight: 'normal',
      textDecoration: 'none',
      cursor: 'default',
    },
  },

  drillDownEvents: {
    drilldown(e) {
      const chart = this;
      if (!chart.originalCategories) {
        // Save the original categories if they haven't been saved yet
        chart.originalCategories = chart.xAxis[0].categories;
      }
      const drilldownSeries = chart.options.drilldown.series.find((series) => series.id === e.point.drilldown);
      const newCategories = drilldownSeries.data.map((item) => item[0]);
      chart.xAxis[0].setCategories(newCategories, false);
      // hide or show scrollbar after drilldown
      chart.xAxis[0].update({
        scrollbar: {
          enabled: newCategories.length > chart.options.customRange,
        },
      });
    },
    drillup() {
      const chart = this;
      // Restore the original categories
      chart.xAxis[0].setCategories(chart.originalCategories, false);
      // hide or show scrollbar after drillup
      chart.xAxis[0].update({
        scrollbar: {
          enabled: chart.originalCategories.length > chart.options.customRange,
        },
      });
    },
  },

  circleMarker: {
    symbol: 'circle',
    radius: 3, // Adjust the size of the marker
  },

  markerHidden: {
    enabled: false,
    lineWidth: 3,
    fillColor: CHART_COLORS.white,
  },

  scrollbar: {
    barBackgroundColor: '#00948E',
    barBorderRadius: 5,
    height: 9,
    trackBackgroundColor: '#f2f2f2',
    trackBorderRadius: 5,
    rifleColor: '#00948E',
    buttonBackgroundColor: null,
    buttonBorderColor: null,
    buttonArrowColor: null,
  },

  syncEventForScrolling: (chartSyncService: ChartSyncService) => ({
    load(): void {
      const chart = this as Highcharts.Chart;
      const dataLength = chart.xAxis[0].categories.length;
      const extremes = { min: Math.max(0, dataLength - 14), max: dataLength - 1 }; // Set scrollbar to the right initially
      chartSyncService.syncCharts(extremes); // Update on load

      chart.xAxis[0].setExtremes(extremes.min, extremes.max);

      Highcharts.addEvent(chart.xAxis[0], 'afterSetExtremes', (e: ExtremesObject): void => {
        chartSyncService.syncCharts({ min: e.min, max: e.max });
      });
    },
  }),

  /**
   * Reminder:
   * By using this functionality, do not forget to add customRange in high chart options
   */
  eventForScrollingWithManualRedraw: {
    load() {
      const chart = this;
      if (!chart.yAxis || !chart.yAxis[0] || !chart.xAxis || !chart.xAxis[0]) {
        return;
      }
      // Capture initial y-axis extremes before changing x-axis
      const yAxis = chart.yAxis[0];
      chart.initialMin = yAxis.getExtremes().min;
      chart.initialMax = yAxis.getExtremes().max;
      // Set the initial x-axis extremes to the end
      const xAxis = chart.xAxis[0];
      const min = xAxis.dataMin;
      const max = xAxis.dataMax;
      const range = chart.options.customRange;

      // hide scrollbar when periods is less than 30
      const delta = max - range;
      const showScrollbar = delta > 0;
      chart.xAxis[0].update({
        scrollbar: {
          enabled: showScrollbar,
        },
      });
      xAxis.setExtremes(showScrollbar ? delta : min, max, true);
      this.redraw();
    },
    redraw() {
      // Reset y-axis to initial extremes on each redraw
      this.yAxis[0].setExtremes(this.initialMin, this.initialMax, false);
    },
  },

  /**
   * Reminder:
   * By using this functionality, do not forget to add customRange in high chart options
   */
  eventForScrolling: {
    load() {
      const chart = this;
      if (!chart.yAxis || !chart.yAxis[0] || !chart.xAxis || !chart.xAxis[0]) {
        return;
      }
      // Capture initial y-axis extremes before changing x-axis
      const yAxis = chart.yAxis[0];
      chart.initialMin = yAxis.getExtremes().min;
      chart.initialMax = yAxis.getExtremes().max;
      // Set the initial x-axis extremes to the end
      const xAxis = chart.xAxis[0];
      const min = xAxis.dataMin;
      const max = xAxis.dataMax;
      const range = chart.options.customRange;

      // hide scrollbar when periods is less than 30
      const delta = max - range;
      const showScrollbar = delta > 0;
      chart.xAxis[0].update({
        scrollbar: {
          enabled: showScrollbar,
        },
      });
      xAxis.setExtremes(showScrollbar ? delta : min, max, true);
      this.redraw();
    },
  },

  /**
   * Reminder:
   * By using this functionality, do not forget to add customRange in high chart options
   */
  eventForLegendAndScroll: {
    load() {
      // Convert rem to pixels. Assume the root font size is 16px; adjust if necessary.
      const remToPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
      const translateValueX = -0.325 * remToPx;
      const translateValueY = 3.125 * remToPx;

      // Apply the transform property using the converted values
      const legend = this.legend.group;
      legend.translate(translateValueX, translateValueY);

      const chart = this;
      setTimeout(() => {
        // Capture initial y-axis extremes before changing x-axis
        const yAxis = chart.yAxis[0];
        chart.initialMin = yAxis.getExtremes().min;
        chart.initialMax = yAxis.getExtremes().max;
        // Set the initial x-axis extremes to the end
        const xAxis = chart.xAxis[0];
        const min = xAxis.datMin;
        const max = xAxis.dataMax;
        const range = chart.options.customRange;
        // hide scrollbar when periods is less than 30
        const delta = max - range;
        const showScrollbar = delta > 0;
        chart.xAxis[0].update({
          scrollbar: {
            enabled: showScrollbar,
          },
        });
        xAxis.setExtremes(showScrollbar ? delta : min, max, true);
        this.redraw();
      }, 10);
    },
    redraw() {
      // Reapply the translation after each redraw
      const remToPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
      const translateValueX = -0.325 * remToPx;
      const translateValueY = 3.125 * remToPx;

      const legend = this.legend.group;
      legend.translate(translateValueX, translateValueY);
      this.yAxis[0].setExtremes(this.initialMin, this.initialMax, false);
    },
  },

  responsiveLegendTwoYAxis: {
    rules: [
      {
        condition: {
          maxWidth: 500,
        },
        chartOptions: {
          yAxis: [
            {
              title: {
                style: {
                  fontSize: '0.8rem',
                },
              },
              labels: {
                style: {
                  fontSize: '0.8rem',
                },
              },
            },
            {
              title: {
                style: {
                  fontSize: '0.8rem',
                },
              },
              labels: {
                style: {
                  fontSize: '0.8rem',
                },
              },
            },
          ],
          xAxis: {
            labels: {
              style: {
                fontSize: '0.8rem',
              },
            },
          },
          legend: {
            align: 'right',
            floating: true,
            itemWidth: 40,
            itemDistance: 1,
            symbolPadding: 1,
            symbolWidth: 10,
            y: -14,
          },
        },
      },
    ],
  },

  navigation: {
    buttonOptions: {
      enabled: false,
    },
  },

  seriesLabelsWithSuffix: {
    enabled: true,
    style: { color: CHART_COLORS.black12, fontSize: CHART_FONTS.font4 },
    formatter() {
      if (this.y !== 0) {
        return formatNumberWithSuffix(this.y);
      }
      return '';
    },
  },

  stackLabelsWithSuffix: {
    enabled: true,
    style: { color: CHART_COLORS.black12, fontSize: CHART_FONTS.font4 },
    formatter() {
      const value = this.total;

      if (value !== 0) {
        return formatNumberWithSuffix(value);
      }
      return '';
    },
  },

  customKpiStackLabels: {
    enabled: true,
    style: { color: CHART_COLORS.black12, fontSize: CHART_FONTS.font4 },
    formatter() {
      const value = this.total;
      const decimals = getDecimalsForSmallValues(value);
      if (value !== 0) {
        return formatNumberWithSuffix(value, decimals);
      }
      return '';
    },
  },

  grandTotalStackLabels({
    decimals = 2,
    includePercentage = false,
    includeSuffix = false,
  } = {}) {
  return {
    enabled: true,
    style: { color: CHART_COLORS.black12, fontSize: CHART_FONTS.font4 },
    formatter() {
      const sum = calculateSum(this.axis.series, this.x);
      const absValue = Math.abs(sum);

      if (sum !== 0 && ((sum < 0 && this.isNegative) || (sum >= 0 && !this.isNegative))) {
        let formattedNumber = sum.toFixed(decimals);
        let suffix = '';

        if (includeSuffix) {
          if (absValue >= 1000000) {
            formattedNumber = Highcharts.numberFormat(sum / 1000000, 1);
            suffix = 'M';
          } else if (absValue >= 1000) {
            formattedNumber = Highcharts.numberFormat(sum / 1000, 0);
            suffix = 'K';
          }
        }

        if (includePercentage) {
          return formattedNumber + '%';
        }

        return formattedNumber + suffix;
      }
    },
  };
},


dataLabels: {
    enabled: true,
    inside: true,
    color: CHART_COLORS.white,
    rotation: 0,
    style: {
      fontSize: CHART_FONTS.caption2,
      textShadow: false,
      textOutline: 'none',
    },
    formatter() {
      if (this.y !== 0) {
        return Highcharts.numberFormat(this.y, 0);
      }
      if (this.point.shapeArgs.height >= 60) {
        return Highcharts.numberFormat(this.y, 1);
      }
      this.point.visible = false; // <--hide this dataLabel
      return '';
    },
  },

  dataLabelsWithDecimals: {
    enabled: true,
    inside: true,
    color: 'white',
    rotation: 270,
    style: {
      textShadow: false,
      textOutline: 'none',
    },
    // eslint-disable-next-line
    formatter: function () {
      if (this.point.shapeArgs.height >= 60) {
        const decimals = this.y > 100 ? 0 : 1;
        return Highcharts.numberFormat(this.y, decimals);
      }
      this.point.visible = false; // <--hide this dataLabel
      return ''; // <--have to return "something" so, return an empty string
    },
  },


  dataLabelsWithPcnt: {
    enabled: true,
    inside: true,
    color: CHART_COLORS.white,
    rotation: 0,
    style: {
      fontSize: CHART_FONTS.caption2,
      textShadow: false,
      textOutline: 'none',
    },
    formatter() {
      if (this.y !== 0) {
        return Highcharts.numberFormat(this.y, 0) + '%';
      }
      return '';
    },
  },

  dataLabelsWithX: {
    enabled: true,
    inside: true,
    color: CHART_COLORS.white,
    rotation: 0,
    style: {
      fontSize: CHART_FONTS.caption2,
      textShadow: false,
      textOutline: 'none',
    },
    formatter() {
      if (this.y !== 0) {
        return 'x' + Highcharts.numberFormat(this.y, 2);
      }
      return '';
    },
  },

  dataLabelsWithSuffix: {
    enabled: true,
    inside: true,
    color: CHART_COLORS.white,
    rotation: 0,
    style: {
      fontSize: CHART_FONTS.caption2,
      textShadow: false,
      textOutline: 'none',
    },
    formatter() {
      const value = this.y;
      const absValue = Math.abs(value);
      let formattedNumber;
      let suffix = '';

      if (absValue >= 1000000) {
        formattedNumber = Highcharts.numberFormat(Math.abs(value) / 1000000, 1);
        suffix = 'M';
      } else if (absValue >= 1000) {
        formattedNumber = Highcharts.numberFormat(Math.abs(value) / 1000, 0);
        suffix = 'K';
      } else {
        formattedNumber = Highcharts.numberFormat(Math.abs(value), 0);
      }

      return absValue > 10000 ? formattedNumber + suffix : '';
    },
  },
};

export const getChartSeriesObj = (name: string, type: string, prefix = '', suffix = '', yAxis = 0, visible = true, digitsNum = 2) => ({
  name, type, yAxis, visible, data: [],
  tooltip: { pointFormat: `{series.name}: <b>${prefix}{point.y:.${digitsNum}f}${suffix}</b><br>` },
});

export const getChartSecondaryAxis = (name = '', min = 0, digitsNum = 1) => ({
  title: {
    text: name,
    style: { color: CHART_COLORS.black12, fontSize: CHART_FONTS.font3 },
  },
  min,
  labels: {
    format: `{value:.${digitsNum}f}`,
    style: { color: CHART_COLORS.black12, fontSize: '0.75rem' },
  },
  opposite: true,
});

export const parseDate = (incomingDate: string | Date) => {
  if (!incomingDate) {
    return '-';
  }
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const date = new Date(incomingDate);
  return `${monthNames[date.getMonth()]} ${date.getFullYear()}`;
};

/**
 * Wrap in styled div with background -> fix bug tooltip layover the legend
 */
export const addNotTransparentTooltipBackground = (tooltip: any): any => {
  return '<div style="background-color: #FFFFFF; border: 1px solid #EEEFF0; border-radius: 12px; padding: 8px;">' +
    tooltip +
    '</div>';
}

export const formatNumberWithSuffix = (value: number, decimals: number = 0): string => {
  const absValue = Math.abs(value);
  let formattedNumber: string;
  let suffix = '';

  if (absValue >= 1000000) {
    formattedNumber = Highcharts.numberFormat(value / 1000000, decimals);
    suffix = 'M';
  } else if (absValue >= 1000) {
    formattedNumber = Highcharts.numberFormat(value / 1000, decimals);
    suffix = 'K';
  } else {
    formattedNumber = Highcharts.numberFormat(value, decimals);
  }

  return formattedNumber + suffix;
};

export const calculateSum = (series, xValue) => {
  let sum = 0;
  for (const item of series) {
    for (let j = 0; j < item.xData.length; j++) {
      if (item.xData[j] === xValue) {
        sum += item.yData[j];
        break;
      }
    }
  }
  return sum;
};

export const getDecimalsForSmallValues = (value: number): number => {
  const isSmallInteger = Number.isInteger(value) && value < HUNDRED_THOUSANDS;
  return isSmallInteger ? 0 : 2;
};

